module.exports = __webpack_public_path__ + "static/media/ios-resize.f44f2ce3.svg";